import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";

import { H2, LinkButton } from "commons";
import { checkIfScrolledToBottom } from "commons/src/helpers/InfiniteScrollHelpers";

import { NewsItem } from "./NewsItem";
import { Message } from "../../components/Message";
import { routes } from "../../helpers/RouteHelpers";

const SLICE = 5;

export function NewsList({ newsItems, newsError }) {
    const [count, setCount] = useState(SLICE);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    });

    const handleScroll = () =>
        checkIfScrolledToBottom(() => setCount(Math.min(newsItems.length, count + SLICE)));

    const filterNews = () => {
        if (newsError) {
            return [];
        }
        return newsItems.sort((a, b) => moment(b.date) - moment(a.date)).slice(0, count);
    };

    const mapNewsItems = news =>
        news.map(item => (
            <NewsItem
                key={item.articleId}
                title={item.title}
                date={item.date}
                content={item.content}
                links={item.links}
            />
        ));

    const filteredNews = filterNews();
    if (!newsError && filteredNews.length === 0) {
        return <Redirect to={routes.client.home()} />;
    }

    return (
        <Container>
            <H2 textAlign="center" secondary>
                Nucleus news
            </H2>
            <Flex>
                {newsError && <Message warning text={newsError} />}
                {!newsError && mapNewsItems(filteredNews)}
                <div>
                    <LinkButton to={routes.client.home()}>Home</LinkButton>
                </div>
            </Flex>
        </Container>
    );
}

const Container = styled.div`
    max-width: 860px;
    width: 100%;
    margin: 0 auto;
`;

const Flex = styled.div`
    display: flex;
    flex-direction: column;
`;

NewsList.propTypes = {
    newsItems: PropTypes.arrayOf(
        PropTypes.shape({
            articleId: PropTypes.number,
            title: PropTypes.string,
            content: PropTypes.string,
            link: PropTypes.object
        })
    ),
    newsError: PropTypes.string,
    dateFilter: PropTypes.string
};
